import * as React from 'react';
import { capitalize } from '@material-ui/core/utils';
import clsx from 'clsx';

var getUtilityClass = function getUtilityClass(name) {
  return "MuiSlider-valueLabel".concat(capitalize(name));
};

var useValueLabelClasses = function useValueLabelClasses(props) {
  var open = props.open,
      valueLabelDisplay = props.valueLabelDisplay;
  var utilityClasses = {
    offset: clsx('MuiSlider-valueLabel', getUtilityClass('offset'), (open || valueLabelDisplay === 'on') && getUtilityClass('open')),
    circle: getUtilityClass('circle'),
    label: getUtilityClass('label')
  };
  return utilityClasses;
};
/**
 * @ignore - internal component.
 */


function ValueLabel(props) {
  var children = props.children,
      className = props.className,
      value = props.value,
      valueLabelDisplay = props.valueLabelDisplay,
      _props$components = props.components,
      components = _props$components === void 0 ? {} : _props$components,
      theme = props.theme;
  var classes = useValueLabelClasses(props);

  if (valueLabelDisplay === 'off') {
    return children;
  }

  var Root = components.Root || 'span';
  return /*#__PURE__*/React.cloneElement(children, {
    className: clsx(children.props.className)
  }, /*#__PURE__*/React.createElement(Root, {
    className: clsx(classes.offset, className),
    theme: theme
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.circle
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.label
  }, value))));
}

export default ValueLabel;